import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "image-card-grid__notice--mobile"
}
const _hoisted_3 = { class: "image-card-grid__cards" }
const _hoisted_4 = {
  key: 0,
  class: "image-card-grid__notice--desktop"
}

import ImageCard from '@lmt-rpb/Atoms/ImageCard/ImageCard.vue';
import { storeToRefs } from 'pinia';
import PromotionNotice, { type Props as PromotionNoticeProps } from '../PromotionNotice/PromotionNotice.vue';
import { useBreakpointStore } from 'src/store/breakpointsStore';
import { computed } from 'vue';

interface ImageCardItem {
	image?: string;
	link: string;
	title: string;
	cta_label?: string;
	title_sr_only?: boolean;
	disable_gradient?: boolean;
}

export interface ImageCardGridProps {
	/* Number of columns to display in the grid. Defaults to 5. */
	cols?: number;
	/* Title for the grid, used for accessibility. */
	title?: string;
	/* Array of image card items to display in the grid. */
	imageCards: ImageCardItem[];
	/* Optional promotion notice to display above or in the grid. */
	promotionNotice?: PromotionNoticeProps;
	/* Layout type for the grid, can be 'small' or 'big'. Defaults to 'small'. */
	layout?: 'small' | 'big';
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ImageCardGrid',
  props: {
    cols: { default: 5 },
    title: {},
    imageCards: {},
    promotionNotice: {},
    layout: { default: 'small' }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "09be170c": (_cols.value)
}))



const { isDesktop } = storeToRefs(useBreakpointStore());
const isBigLayout = computed(() => __props.layout === 'big');
const _cols = computed(() => Math.max(1, __props.cols));
const hasImages = computed(() => __props.imageCards?.length > 0);
const shouldRenderNoticeInGrid = computed(() => hasImages.value && isDesktop.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "image-card-grid rpb_container",
    role: "navigation",
    "aria-label": _ctx.title
  }, [
    (!shouldRenderNoticeInGrid.value && _ctx.promotionNotice && !isBigLayout.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(PromotionNotice, _normalizeProps(_guardReactiveProps(_ctx.promotionNotice)), null, 16 /* FULL_PROPS */)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      (shouldRenderNoticeInGrid.value && _ctx.promotionNotice && !isBigLayout.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(PromotionNotice, _normalizeProps(_guardReactiveProps(_ctx.promotionNotice)), null, 16 /* FULL_PROPS */)
          ]))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageCards, (imageCard) => {
        return (_openBlock(), _createBlock(ImageCard, {
          key: imageCard.link + imageCard.title,
          size: isBigLayout.value ? 'large' : 'small',
          "bg-image": imageCard.image,
          "bg-image-alt": imageCard.title,
          href: imageCard.link,
          "sr-only": imageCard.title_sr_only,
          "no-gradient": imageCard.disable_gradient,
          title: imageCard.title,
          "data-ga-event": "select_content",
          "data-ga-content_type": "ux_plugin_image_card_click",
          "data-ga-content_id": imageCard.title
        }, _createSlots({ _: 2 /* DYNAMIC */ }, [
          (imageCard.cta_label)
            ? {
                name: "chipContent",
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(imageCard.cta_label), 1 /* TEXT */)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["size", "bg-image", "bg-image-alt", "href", "sr-only", "no-gradient", "title", "data-ga-content_id"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 8 /* PROPS */, _hoisted_1))
}
}

})